import Form from '../../../../form_builder_2/form';
import AnalyticsHelper from '../../../../utils/analytics-helper';

export default class DigitalServiceRecord {
    constructor(parent) {
        this.parent = parent;
        this.el = parent.el.querySelector('.digital-service-record-view');
        this.nav = parent.el.querySelector('.my-account-nav--menu');
        this.dsrForm = parent.el.querySelector('.digital-service-record-form');
        this.dsrContainer = parent.el.querySelector('.digital-service-record-details-container');
        this.dsrDetails = parent.el.querySelector('.digital-service-record-details');
        this.form = new Form(this.dsrForm, {
            onSuccess: this.onSuccess.bind(this),
            onError: this.onError.bind(this),
        });
        this.formLoader = this.el.querySelector('.form_loader');

        this.dsrDetailsViewTemplate = _.template(parent.el.querySelector('#dsrDetailsView').innerHTML.replaceAll('\\', ''));
        this.backToVinLookup = parent.el.querySelector('#back-to-vin');

        this.dsrVinContainer = parent.el.querySelector('.digital-service-record-vin-container');
        this.dsrNoVinWrapper = this.dsrVinContainer.querySelector('.no-vin-wrapper');
        this.dsrVinWrapper = this.dsrVinContainer.querySelector('.vin-wrapper');
        this.dsrVinListWrapper = this.dsrVinWrapper.querySelector('.vin-list-wrapper');

        this.dsrVinListTemplate = _.template(parent.el.querySelector('#dsrVinList').innerHTML.replaceAll('\\', ''));
        this.dsrVinList = null;

        this.bind();
    }

    bind() {
        // Bind form to update user details
        this.backToVinLookup.addEventListener('click', (e) => {
            e.preventDefault();
            this.backToVin();
        });

        window.HONDA.MyAccount2.addEventListener('login', () => this.fetchDSR());
    }

    async fetchDSR() {
        this.resetDsrDetails();
        this.clearVinList();
        this.formLoader.classList.remove('hide');
        const result = await window.HONDA.MyAccount2.client.getDsrDetails();
        this.dsrVinList = result?.success ? result?.data : [];
        this.renderVinList();
        this.formLoader.classList.add('hide');
    }

    clearVinList() {
        this.dsrVinList = null;
        this.renderVinList();
    }

    renderVinList() {
        if (!this.dsrVinList || !this.dsrVinList.length) {
            this.dsrNoVinWrapper.classList.remove('hide');
            this.dsrVinWrapper.classList.add('hide');
        } else {
            this.dsrNoVinWrapper.classList.add('hide');
            this.dsrVinWrapper.classList.remove('hide');
            this.dsrVinListWrapper.innerHTML = this.dsrVinListTemplate({ vinList: this.dsrVinList });

            const vinCtas = this.dsrVinListWrapper.querySelectorAll('.cta-vin');
            vinCtas.forEach((cta) => {
                cta.addEventListener('click', (e) => {
                    e.preventDefault();

                    const { vin } = cta.dataset;
                    const data = this.dsrVinList.filter((v) => v.vehicle.vin === vin)[0];
                    this.populate(data);
                    this.dsrContainer.classList.remove('hide');
                    this.dsrForm.classList.add('hide');
                    this.dsrVinContainer.classList.add('hide');
                });
            });
        }
    }

    show() {
        this.resetDsrDetails();
        this.el.classList.remove('hide');
    }

    hide() {
        this.el.classList.add('hide');
    }

    onSuccess(result) {
        const data = result?.data;
        this.populate(data);
        this.dsrContainer.classList.remove('hide');
        this.dsrForm.classList.add('hide');
        this.dsrVinContainer.classList.add('hide');
        this.analyticsPush(result);
    }

    onError(result) {
        this.form.showError();
    }

    populate(data) {
        this.dsrDetails.innerHTML = this.dsrDetailsViewTemplate({ data });
    }

    resetDsrDetails() {
        this.dsrDetails.innerHTML = '';
        this.backToVin();
    }

    backToVin() {
        this.dsrContainer.classList.add('hide');
        this.dsrForm.classList.remove('hide');
        this.dsrVinContainer.classList.remove('hide');
    }

    analyticsPush() {
        AnalyticsHelper.push({
            event: 'garage',
            eventCategory: 'garage',
            eventAction: 'search',
            eventLabel: 'cars|My account garage|search|internal|#',
            actionType: 'search',
            businessUnit: 'cars',
            moduleName: 'My account garage',
            clickText: 'search',
            clickType: 'internal',
            destinationURL: '#',
        });
    }
}
